<script setup lang="ts">
import { howItWorks } from '@/data/howItWorks'
import { useLangTools } from '@/lang'
import { useRouter } from 'vue-router'

const { $tdb } = useLangTools(useRouter())
</script>

<template>
	<div class="cta relative">
		<h3 class="playfair act_txt30 act_w770">
			{{ $tdb(howItWorks[0], 'cta') }}
		</h3>
		<LocalLink to="/get-the-best-offer" class="act_btn absolute">
			{{ $t("cta.getStarted") }}
		</LocalLink>
	</div>
</template>

<style>
.cta {
  border: var(--blue) 1px solid;
  position: relative;
  padding: 2rem 2rem 3rem;
}

.cta .act_btn {
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 275px;
  bottom: -1.5rem;
}
</style>
